import styled, { css } from 'styled-components';

// @ts-nocheck
var LinkList = styled.ul.withConfig({
  displayName: "LinkListstyle__LinkList",
  componentId: "sc-hp2pvj-0"
})(["display:flex;gap:var(--space-500);position:relative;z-index:3;", ""], function (_ref) {
  var $variant = _ref.$variant;
  return $variant === 'room' && css(["margin-top:auto;"]);
});
var LinkListItem = styled.li.withConfig({
  displayName: "LinkListstyle__LinkListItem",
  componentId: "sc-hp2pvj-1"
})([""]);

export { LinkList, LinkListItem };
//# sourceMappingURL=LinkList.style.js.map
